import React, { useState, useEffect } from 'react';

import LabelTag from './LabelTag';
import LabelDropdown from './LabelDropdown';
import { matchOptions } from '../shared/EventHelpers';
import { getIcon } from '../shared/FormatHelpers';

const LabelSelector = ({ value, setValue, options, inputRef, showOptions, setShowOptions, onSave, showLabelIcon, handleCancel }) => {
    const [userInput, setUserInput] = useState('');
    const [activeIndex, setActiveIndex] = useState(-1);
    const [matchedOptions, setMatchedOptions] = useState(options);
    const [shouldSave, setShouldSave] = useState(false);

    useEffect(() => {
        setMatchedOptions(matchOptions(options, userInput));
        setActiveIndex(-1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInput, options]);

    useEffect(() => {
        if (shouldSave) {
            onSave && onSave();
            setShouldSave(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldSave]);

    const setSelectedItem = () => {
        if (activeIndex < 0 || activeIndex >= matchedOptions.length) {
            return;
        }
        if (matchedOptions[activeIndex].id) {
            setValue(matchedOptions[activeIndex]);
        } else {
            setValue(null);
        }
        setActiveIndex(-1);
        setUserInput('');
        setShowOptions(false);
        setShouldSave(true);
    };

    const scrollToIndex = (index) => {
        const divToScrollTo = document.getElementById(`suggestion-${index}`);
        if (divToScrollTo) {
            divToScrollTo.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
    };

    const onMouseDown = (event) => {
        if (activeIndex >= 0) {
            setSelectedItem();
            event.preventDefault();
        }
    };

    const onKeyDown = (event) => {
        // Enter adds selected item
        if (event.keyCode === 13) {
            if (activeIndex >= 0) {
                setSelectedItem();
                event.preventDefault();
            } else {
                setShowOptions(false);
            }
        }

        // Up-arrow moves up in list
        else if (event.keyCode === 38) {
            if (activeIndex > -1) {
                setActiveIndex(activeIndex - 1);
                scrollToIndex(activeIndex - 1);
            }
            event.preventDefault();
        }

        // Down-arrow moves down in list
        else if (event.keyCode === 40) {
            if (activeIndex < matchedOptions.length) {
                setActiveIndex(activeIndex + 1);
                scrollToIndex(activeIndex + 1);
            }
            event.preventDefault();
        }

        // Esc closes dropdown
        else if (event.keyCode === 27) {
            handleCancel();
            event.preventDefault();
        }
    };

    const onBlur = () => {
        setUserInput('');
        setShowOptions(false);
    };

    const onFocus = () => {
        setShowOptions(true);
        if (value?.id && options && options.length) {
            setActiveIndex(options.findIndex((o) => o.id === value.id) ?? -1);
        }
    };

    return (
        <div className='new-item-selector label-selector'>
            <div className='d-flex flex-nowrap align-items-center'>
                {showLabelIcon && getIcon('label')}
                {value && <LabelTag {...{ value }} />}
                <input
                    ref={inputRef}
                    value={userInput}
                    onChange={(e) => setUserInput(e.target.value)}
                    onKeyDown={onKeyDown}
                    onBlur={onBlur}
                    onFocus={onFocus}
                />
                <div style={{ transform: showOptions ? 'rotate(180deg)' : '' }} className='chevron'>
                    {getIcon('chevron-down')}
                </div>
            </div>
            <LabelDropdown {...{ options: matchedOptions, showOptions, activeIndex, setActiveIndex, onMouseDown }} />
        </div>
    );
};

export default LabelSelector;
